/* Vita Sané — riel del carrusel de la línea (sección `kdg-vs-linea`).
 *
 * Sin dependencias. El CSS resuelve lo visual; esto mueve el scroll y
 * sincroniza flechas y dots.
 *
 * La navegación va por OFFSETS REALES DE TARJETA, no por múltiplos del ancho
 * visible. Con `scroll-snap-type: x mandatory` el navegador ajusta el scroll a
 * la tarjeta más cercana: al pedir "una pantalla más" el destino caía en medio
 * de una tarjeta, el snap lo corregía a otro sitio y el índice leído de vuelta
 * ya no era el pedido. En el extremo pedía una posición mayor que el máximo
 * alcanzable y el riel se quedaba clavado sin avanzar.
 *
 * Degradación: sin este JS el riel sigue siendo scroll horizontal nativo con
 * snap; los controles quedan ocultos hasta que el JS los habilita.
 */
(function () {
  'use strict';

  var SECTION_NAME = 'kdg-vs-linea';
  var SECTION_SELECTOR = '[data-kdg-section="' + SECTION_NAME + '"]';

  // ---- motor puro (sin DOM): testeable con node ----

  // Posiciones de scroll a las que el riel puede llegar DE VERDAD.
  // Se descartan los offsets que superan el máximo (esas tarjetas ya quedan
  // visibles al final del recorrido) y se añade el tope si la última tarjeta
  // alcanzable no llega hasta él, para que el último paso muestre el final.
  function stops(offsets, maxScroll) {
    var out = [];
    for (var i = 0; i < offsets.length; i++) {
      if (offsets[i] <= maxScroll - 1) out.push(offsets[i]);
    }
    if (!out.length) return [0];
    if (maxScroll - out[out.length - 1] > 1) out.push(maxScroll);
    return out;
  }

  // Índice de la parada más cercana a la posición actual.
  function nearestStop(list, scrollLeft) {
    if (!list || !list.length) return 0;
    var best = 0;
    var bestDist = Math.abs(list[0] - scrollLeft);
    for (var i = 1; i < list.length; i++) {
      var d = Math.abs(list[i] - scrollLeft);
      // `<` y no `<=`: ante empate gana el de menor índice, que es el que el
      // usuario percibe como "el de la izquierda".
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    }
    return best;
  }

  if (typeof window === 'undefined' && typeof module !== 'undefined' && module.exports) {
    module.exports = { stops: stops, nearestStop: nearestStop };
    return;
  }

  if (window.__kdgVsCarruselLoaded) return;
  window.__kdgVsCarruselLoaded = true;

  function initSection(section) {
    if (!section || section.dataset.kdgReady === '1') return;

    var rail = section.querySelector('[data-kdg-rail]');
    if (!rail || !rail.children.length) return;

    section.dataset.kdgReady = '1';

    var dots = [].slice.call(section.querySelectorAll('[data-kdg-dot]'));
    var prev = section.querySelector('[data-kdg-prev]');
    var next = section.querySelector('[data-kdg-next]');
    var paradas = [0];
    var current = 0;

    function medir() {
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      var offsets = [];
      for (var i = 0; i < rail.children.length; i++) {
        offsets.push(rail.children[i].offsetLeft - rail.offsetLeft);
      }
      paradas = stops(offsets, maxScroll);

      // Liquid pinta un dot por producto porque no sabe cuántos caben;
      // acá se ocultan los que no corresponden a una parada real.
      for (var d = 0; d < dots.length; d++) {
        dots[d].hidden = d >= paradas.length;
      }
      section.dataset.kdgControls = paradas.length > 1 ? 'on' : 'off';
      sync();
    }

    function sync() {
      current = nearestStop(paradas, rail.scrollLeft);
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === current ? 'true' : 'false');
      }
      if (prev) prev.disabled = current <= 0;
      if (next) next.disabled = current >= paradas.length - 1;
    }

    function irA(i) {
      var t = Math.max(0, Math.min(paradas.length - 1, i));
      rail.scrollTo({ left: paradas[t], behavior: 'smooth' });
    }

    // Se lee `current` en el momento del clic, no una copia: con dos clics
    // seguidos el scroll suave aún no terminó y una copia mandaría al mismo sitio.
    if (prev) prev.addEventListener('click', function () { irA(current - 1); });
    if (next) next.addEventListener('click', function () { irA(current + 1); });
    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { irA(idx); });
    });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });

    // El nº de columnas cambia por breakpoint, así que las paradas también.
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(medir).observe(rail);
    } else {
      window.addEventListener('resize', medir);
    }

    medir();
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches(SECTION_SELECTOR)) initSection(scope);
    var found = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < found.length; i++) initSection(found[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
